(function(UIElements, _) {
    /* jshint maxcomplexity: 5, maxdepth: 2, maxstatements: 15 */
    'use strict';
    var getSvgHelper = function(conf) {
        var xlmns = 'http://www.w3.org/2000/svg';
        var createSvgEl = Odigeo._.bind(document.createElementNS, document, xlmns);
        var setSvgAttrs = function(el, attrs) {
            Odigeo._.each(attrs, function(value, key) {
                el.setAttribute(key, value);
            });
            return el;
        };
        var svgCanvas = setSvgAttrs(createSvgEl('svg'), {
            'version': '1.1',
            'xlmns': xlmns,
            'class': conf.svgClass,
            'role': 'img',
        });
        var childNodes = svgCanvas.childNodes;
        var currentNode = 0;
        var updateFigure = setSvgAttrs;
        var addFigure = function(type, attrs) {
            svgCanvas.appendChild(setSvgAttrs(createSvgEl(type), attrs));
        };

        return {
            getSvgCanvas: Odigeo._.constant(svgCanvas),
            paintRectangle: function(attrs) {
                var figure = childNodes[currentNode];
                currentNode += 1;
                //  Return value not useful.
                return figure ? updateFigure(figure, attrs) : addFigure('rect', attrs);
            },
            refreshCanvas: function() {
                setSvgAttrs(svgCanvas, Odigeo._.pick(conf, 'width', 'height'));
                currentNode = 0;
            },
        };
    };

    function calculateBarWidth(bars, conf) {
        return (conf.unit === '%' ? 100 : conf.width) / Odigeo._.size(bars);
    }

    function calculateWidth($parent, conf) {
        return (conf.unit === '%' ? '100%' : $parent.width());
    }

    function drawBar(percentage, index, bars) {
        var barWidth = calculateBarWidth(bars, this.conf);
        var canvasHeight = this.conf.height;
        var barHeight = canvasHeight * percentage;

        this.drawHelper.paintRectangle({
            'class': this.conf.barClass,
            'width': barWidth + this.conf.unit,
            'height': barHeight,
            'x': index * barWidth + this.conf.unit,
            'y': canvasHeight - barHeight,
        });
    }

    function appendCanvas($parent, drawHelper) {
        $parent.append(drawHelper.getSvgCanvas());
    }

    function init($parent, conf) {
        var drawHelper = getSvgHelper(conf);
        var histogram = {
            refresh: refresh,
            parent: $parent,
            drawHelper: drawHelper,
            histogramBars: [],
            conf: conf,
        };
        appendCanvas($parent, drawHelper);
        return histogram;
    }

    function updateState() {
        Odigeo._.extend(this.conf, {width: calculateWidth(this.parent, this.conf), height: this.parent.height()});
        this.drawHelper.refreshCanvas();
    }

    function paintHistogramBars() {
        this.histogramBars.forEach(Odigeo._.bind(drawBar, this));
    }

    function refresh(newHistogramBars) {
        this.histogramBars = newHistogramBars || this.histogramBars;
        updateState.call(this);
        paintHistogramBars.call(this);
    }

    UIElements.histogram = function($parent, options) {
        var conf = Odigeo._.extend({
            svgClass: 'chart',
            barClass: 'bar',
            unit: '',
        }, options);
        var histogram = init($parent, conf);
        return histogram;
    };
}(Odigeo.UIElements, _));
